<template>
  <Modal
    :id="'cmp-royalty-accounts-advanced_search'"
    :loading="loading"
    @cancelled="onCancel"
  >
    <template slot="header">{{
      $dft.snakeCaseToWords("accounts_advanced_search")
    }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <Dropdown
            :options="advancedSearchData.label_statusesTV || []"
            :selected="selectedStatus"
            :placeholder="$t('status')"
            box
            deselect
            v-on:selectedChange="(e) => onStatusChange('label_status_id', e)"
          >
            <template v-slot:item="{ item }">
              <div class="choose-status-dropdown">
                <div
                  class="choose-status-dropdown--color"
                  :style="{
                    backgroundColor: `#${
                      advancedSearchData.label_statuses.find(
                        (e) => e.label_status_id == item.value
                      ).label_status_colour
                    }`,
                  }"
                ></div>

                <div class="choose-status-dropdown--name">
                  {{ item.text }}
                </div>
              </div>
            </template>
          </Dropdown>
          <!-- <Dropdown
            :id="'label_status_type'"
            class="m2"
            :options="advancedSearchData.label_statusesTV || []"
            :selected="
              advancedSearchData.label_statusesTV.find(
                (t) => t.value == label_status_type
              )
            "
            :placeholder="$t('status')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('label_status_type', e)"
            :listHeight="250"
          ></Dropdown> -->
          <!-- <TextField
            :id="'sage_id_str'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="sage_id_str"
            isModel
            :placeholder="$t('Royalty Account Id')"
            @valuechanged="onTextFieldValueChange"
          /> -->
          <TextField
            :id="'royalty_account_name'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="royalty_account_name"
            isModel
            :placeholder="$t('royalty_account_name')"
            @valuechanged="onTextFieldValueChange"
          />
          <!-- <Dropdown
            :id="'currency'"
            class="m2"
            :options="advancedSearchData.currenciesTV  || []"
            :selected="
              advancedSearchData.currenciesTV.find((t) => t.value == currency)
            "
            :placeholder="$t('currency')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('currency', e)"
            :listHeight="250"
          ></Dropdown> -->
          <!-- <Dropdown
            :id="'company_id'"
            class="m2"
            :options="advancedSearchData.companiesTV"
            :selected="
              advancedSearchData.companiesTV.find(
                (x) => x.value == company_id
              )
            "
            :placeholder="'Legal Entity'"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('company_id', e)"
          ></Dropdown> -->

          <Dropdown
            :id="'invoice_project_id'"
            class="m2"
            :options="advancedSearchData.invoice_projectsTV"
            :selected="
              advancedSearchData.invoice_projectsTV.find(
                (x) => x.value == invoice_project_id
              )
            "
            :placeholder="'Royalty Layout'"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
          ></Dropdown>
          <Dropdown
            :id="'payment_yes_no'"
            class="m2"
            :options="advancedSearchData.account_basesTV"
            :selected="
              advancedSearchData.account_basesTV.find(
                (x) => x.value == payment_yes_no
              )
            "
            :placeholder="$t('Account Base')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('payment_yes_no', e)"
          ></Dropdown>
          <Dropdown
            :id="'vat_type'"
            class="m2"
            :options="advancedSearchData.vat_typesTV"
            :selected="
              advancedSearchData.vat_typesTV.find((x) => x.value == vat_type)
            "
            :placeholder="$t('vat')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('vat_type', e)"
          ></Dropdown>
          <Dropdown
            :id="'tax_type_id'"
            class="m2"
            :options="advancedSearchData.tax_typesTV"
            :selected="
              advancedSearchData.tax_typesTV.find((x) => x.value == tax_type_id)
            "
            :placeholder="$t('Tax Group')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('tax_type_id', e)"
          ></Dropdown>
          <Dropdown
            :id="'country_fullname'"
            class="m2"
            :options="advancedSearchData.countriesTV"
            :selected="
              advancedSearchData.countriesTV.find(
                (x) => x.value == country_fullname
              )
            "
            :placeholder="$t('contact_country')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('country_fullname', e)"
          ></Dropdown>
          <Dropdown
            :id="'royalty_period'"
            class="m2"
            :options="advancedSearchData.royalty_periodsTV"
            :selected="
              advancedSearchData.royalty_periodsTV.find(
                (x) => x.value == royalty_period
              )
            "
            :placeholder="$t('period')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('royalty_period', e)"
          ></Dropdown>
          <Dropdown
            :id="'statement_type'"
            class="m2"
            :options="advancedSearchData.statement_TypeTV"
            :selected="
              advancedSearchData.statement_TypeTV.find(
                (x) => x.value == statement_type
              )
            "
            :placeholder="$t('mailing')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('statement_type', e)"
          ></Dropdown>
        </div>
      </div>
    </template>

    <template slot="options">
      <div class="options">
        <button class="dt-button s6" @click.stop="onCancel">Close</button>
        <button
          class="dt-button v1 s6"
          @click.stop="onSearch"
          :disabled="this.isFilterEmpty()"
          :class="{
            disabled: this.isFilterEmpty(),
          }"
          :title="this.isFilterEmpty() ? filterEmptyError() : ''"
        >
          Search
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import TextField from "@plugins/text-field/text-field";
import { AccountsService } from "../../services/accounts.service";
import {
  ensureBoolIntObjectFromKeys,
  ensureStringObjectFromKeys,
} from "../../../../utility/fp";
import { createAdvancedSearchModal } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";

export const accountListAdvancedSearchConfig = createAdvancedSearchConfig({
  searchConfigStringKeys: [
    "label_status_id",
    "royalty_account_name",
    "invoice_project_id",
    "payment_yes_no",
    "vat_type",
    "tax_type_id",
    "country_fullname",
    "royalty_period",
    "statement_type",
  ],
  searchConfigIntKeys: [],
  booleanSearchKeyLabelMap: {},

  searchConfigTVMap: [
    ["label_status_id", "label_statusesTV"],
    ["label_status_id", "label_statuses"],
    ["invoice_project_id", "invoice_projectsTV"],
    ["payment_yes_no", "account_basesTV"],
    ["vat_type", "vat_typesTV"],
    ["tax_type_id", "tax_typesTV"],
    ["country_fullname", "countriesTV"],
    ["royalty_period", "royalty_periodsTV"],
    ["statement_type", "statement_TypeTV"],
  ],
  searchConfigMulTVMap: [],
  searchConfigOmitKeyMap: [],
});

export default {
  components: {
    Modal,
    TextField,
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true,
      },
      chooseStatusItems: [],
      royalty_period: "",
      label_status_id: "",
      sage_id_str: "",
      royalty_account_name: "",
      currency: "",
      company_id: "",
      invoice_project_id: "",
      payment_yes_no: "",
      vat_type: "",
      tax_type_id: "",
      country_fullname: "",
      loading: false,
      selectedStatus: null,
      statement_type: "",
    };
  },
  mixins: [createAdvancedSearchModal(accountListAdvancedSearchConfig)],
  computed: {
    searchFilter: function () {
      return {
        ...ensureStringObjectFromKeys(
          this,
          accountListAdvancedSearchConfig.searchConfigStringKeys
        ),
        ...ensureBoolIntObjectFromKeys(
          this,
          accountListAdvancedSearchConfig.booleanSearchKeys
        ),
        ...ensureBoolIntObjectFromKeys(
          this,
          accountListAdvancedSearchConfig.searchConfigIntKeys
        ),
      };
    },
  },
  methods: {
    onTextFieldValueChange: function (name, value) {
      this[name] = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (name, value) {
      this[name] = value.value;
    },
    onStatusChange: function (name, value) {
      this.selectedStatus = value;
      this[name] = value.value;
    },

    onSearch: async function () {
      if (this.isFilterEmpty()) {
        return;
      }
      this.$emit("search", this.searchFilter);
    },

    filterEmptyError() {
      return `Please provide value to any one of these Fields - Account, Title, Version, Track type, Digital right, Genres, Isrc error, Missing main product, Product track mismatch, Licence account, Main label, Any label, Royalty account, No contract, Playtime missing, Composer missing, Composer, Writer missing, Writer, Publisher missing, Publisher, Producer missing, Producer, Arranger missing, Arranger, Metadata value1, Metadata value2, Metadata value3, Track grid`;
    },
    isFilterEmpty() {
      let {
        royalty_period,
        label_status_id,
        sage_id_str,
        royalty_account_name,
        currency,
        company_id,
        invoice_project_id,
        payment_yes_no,
        vat_type,
        tax_type_id,
        country_fullname,
        statement_type,
      } = this;

      if (
        !royalty_period &&
        !label_status_id &&
        !sage_id_str &&
        !royalty_account_name &&
        !currency &&
        !company_id &&
        !invoice_project_id &&
        !payment_yes_no &&
        !vat_type &&
        !tax_type_id &&
        !country_fullname &&
        !statement_type
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-accounts-advanced_search {
  .body-container {
    max-height: 500px;
    padding-right: 15px;
    overflow: hidden;
    overflow-y: auto;

    .dropdown,
    .dt-input-box--container,
    .date-control {
      max-width: 358px;
    }
  }
  .options {
    margin-right: 15px !important ;
    display: flex;
  }

  .omit-toggler {
    display: flex;
    cursor: pointer;

    &.missed {
      color: var(--c-error);
    }

    .omit-toggler--label {
      margin: auto 0px auto 4px;
      cursor: pointer;
    }
  }

  .search--input {
    flex: 1;
  }

  .search--checkbox {
    min-width: 20px;
    margin-left: 4px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: 320px) and (max-width: 480px) {
      padding-left: 0px;
      margin-left: 0px;

      .checkmark {
        margin-left: 10px;
      }
    }
  }

  .checkbox-container {
    .dt-checkbox-control {
      align-items: center;
      .dt-checkbox-label {
        flex: 1;
        padding-left: 10px;
      }
    }
  }

  .row-control {
    margin: 10px 0;
    .search--input {
      max-width: 100%;
    }
  }
  .date-control {
    .dt-input-box--container {
      flex: 1;
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }
}

.choose-status-dropdown {
  display: flex;
  margin-left: -15px;
  &--color {
    margin-left: 10px;
    flex: 1;
    width: 13px;
    min-width: 13px;
    max-width: 13px;
    height: 13px;

    margin-top: auto;
    margin-bottom: auto;

    border-radius: 50%;
    box-shadow: 0 0 1px #fff;
  }
  &--name {
    margin-left: 10px;
  }
  .dt-icon-container {
    margin-left: 3px;
  }
  .dt-icon-container + &--name {
    margin-left: 5px;
  }
}
</style>